import { gql } from "lib/apolloClient";
import {
  childFragment,
  curriculumProgramFragment,
  studentFragment,
  staffFragment,
  userIdentityDetailFragment,
  courseFragment,
  studentsAlertFragment,
} from "modules/CommonFragments";
import {
  childFragmentForStaff,
  parentFragment,
} from "./FamilyProfileFragments";

export const getPlatformUserDetailsQuery = gql`
  query getPlatformUserDetails($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        ...staffItem
        ...staffCoachMarksItem
        firstLoggedInAt
        type
        designation {
          id
          title
        }
        allCourses {
          id
          academicYears {
            id
          }
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
        }
        jwt
        userIdentityDetails {
          ...userIdentityDetailItem
        }
        linkedIdentityUsersV2 {
          totalCount
        }
        linkedIdentityV2 {
          id
        }
        organization {
          id
          name
          tier {
            plan
            isFree
          }
          academicYears {
            id
            isCurrentAcademicYear
          }
          curriculumPrograms {
            ...subscriptionPlanDetailsItem
          }
        }
      }
      ... on Student {
        ...studentItem
        ...studentCoachMarksItem
        type
        allCourses {
          id
          academicYears {
            id
          }
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
        }
        jwt
        linkedIdentityUsersV2 {
          totalCount
        }
        organization {
          id
          name
          tier {
            plan
            isFree
          }
          academicYears {
            id
            isCurrentAcademicYear
          }
          curriculumPrograms {
            ...subscriptionPlanDetailsItem
          }
        }
      }
      ... on FamilyMember {
        ...parentItem
        status
        communicationState {
          id
          messageType
          isSeen
          appType
        }
        children {
          ...childItem
          curriculumPrograms {
            id
            type
          }
          organization {
            id
            name
            tier {
              plan
              isFree
            }
            academicYears {
              id
              isCurrentAcademicYear
            }
            curriculumPrograms {
              ...subscriptionPlanDetailsItem
            }
          }
          allCourses {
            id
            academicYears {
              id
            }
            curriculumProgram {
              ...curriculumProgramBasicDetailsItem
            }
          }
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
        }
      }
    }
  }
  ${curriculumProgramFragment.subscriptionPlanDetails}
  ${childFragmentForStaff.basicChildDetails}
  ${parentFragment.basicParentDetails}
  ${studentFragment.basicStudentDetails}
  ${studentFragment.studentCoachMarks}
  ${staffFragment.basicStaffDetails}
  ${staffFragment.staffCoachMarks}
  ${userIdentityDetailFragment.userIdentityDetail}
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
`;

export const getChildrenQueryForStaff = gql`
  query getChildren(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $organizationId: ID
    $teacherId: ID
    $includeInvitedStudents: Boolean
  ) {
    node(id: $id, type: $type) {
      id
      ... on FamilyMember {
        children(
          organizationId: $organizationId
          teacherId: $teacherId
          includeInvitedStudents: $includeInvitedStudents
        ) {
          ...childItem
          ...childDetailsItem
          ... on Student {
            alertTypes {
              ...alertTypeFields
            }
          }
          courses {
            ...courseItem
            curriculumProgram {
              ...curriculumProgramBasicDetailsItem
            }
          }
        }
      }
    }
  }
  ${studentsAlertFragment}
  ${childFragmentForStaff.basicChildDetails}
  ${childFragment.childDetails}
  ${courseFragment.basicCourserDetails}
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
`;
